<form id="frmRse" #frmRse="ngForm" name="frmRse" autocomplete="off" *ngIf="supplierAnswsers"
    class="full-width d-flex flex-column align-items-stretch justify-content-start rseScreen">

    
    <div *ngFor="let g of supplierAnswsers.rootsGroups"  [ngStyle]="supplierAnswsers.ngStyle(g)">
        <app-supplier-rse-qst-group [rseGroup]="g"
        [supplierAnswsers]="supplierAnswsers" class="full-width" [frmRse]="frmRse"
        [readonly]="readonly"  (valueChange)="onValueChanged()"></app-supplier-rse-qst-group>
    </div>

    
    <!-- <div class="rseIndicateurWrapper d-flex flex-column align-items-stretch justify-content-start" [ngStyle]="{'left':(sharedDatasSvc.detailSupplierToolbarWidth+50).toString()+'px'}">
        <div class="flex-fill">
            <paf-rounded-progress-bar 
                [max]="sharedDatasSvc.rseMaxValue" 
                [current]="supplierAnswsers.rseIndictateurValue"
                [color]="supplierAnswsers.rseIndictateurColor"
                [width]="80"
                [stroke]="5"
                [height]="40"
                labelCod="Note_RSE">
            </paf-rounded-progress-bar>
        </div>
    </div> -->
</form>